import Lottie from 'lottie-react';
import dogTailAnimation from 'lottie/dog-tail.json';

import { LayoutContainer } from 'layout';
import { Button, ButtonSize, SectionContainer } from 'ui';

import {
    contentWrapper,
    headingWrapper,
    animationWrapper,
    sectionContainer,
    screenTablet
} from './examination-thesis-section.module.scss';
import { useMediaQuery } from 'hooks';

export const ExaminationThesisSection = () => {
    const isTablet = useMediaQuery(`(min-width: ${screenTablet})`);

    return (
        <LayoutContainer>
            <SectionContainer className={sectionContainer}>
                <div className={animationWrapper}>
                    <Lottie animationData={dogTailAnimation} loop={true} />
                </div>
                <div className={contentWrapper}>
                    <div className={headingWrapper}>
                        <h3>Examination - Thesis - Career</h3>
                    </div>
                    <p>
                        Elumity brings light to your vision – from your university exams throughout your entire career.
                        We set the stage for you to know better, leaving it up to you to make new insights and
                        discoveries in your field.
                    </p>
                    {!isTablet && (
                        <a href={process.env.GATSBY_ELUMITY_APP_URL + '/signup'}>
                            <Button text="Try it out" size={ButtonSize.Medium} />
                        </a>
                    )}
                </div>
            </SectionContainer>
        </LayoutContainer>
    );
};
